import {Switch} from 'platform/components';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps, useBoolean} from 'shared/web';

const DISABLED_PERSON_DISCOUNT_VAT_RATE = 6;

interface CheckoutDisabledPersonDiscountProps extends TestIdProps {
  isEnabled: boolean;
  isDisabled?: boolean;
  onToggle?: (enabled: boolean) => Promise<void>;
}

export const CheckoutDisabledPersonDiscount = (props: CheckoutDisabledPersonDiscountProps) => {
  const [isLoading, startLoading, stopLoading] = useBoolean();

  const handleToggle = () => {
    if (!props.onToggle) {
      return;
    }

    startLoading();
    props.onToggle(!props.isEnabled).finally(stopLoading);
  };

  return (
    <Switch
      label={i18n.t('entity.checkout.labels.discountForDisabled', {
        vat: DISABLED_PERSON_DISCOUNT_VAT_RATE,
      })}
      value={props.isEnabled}
      isDisabled={(props.isDisabled ?? false) || !props.onToggle}
      isLoading={isLoading}
      onChange={handleToggle}
      data-testid={suffixTestId('disabledPersonDiscount', props)}
    />
  );
};
